import { Service } from '@/tools'
export class SkuService<T extends TCommodity.Sku> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.Sku}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  //作废sku
  invalid = <K extends T['ApiInvalidSku']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInvalidSku', data)
  //激活sku
  activation = <K extends T['ApiActivationSku']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiActivationSku', data)
  //sku打标签
  skuPlayTag = <K extends T['ApiSkuPlayTag']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSkuPlayTag', data)
  //查询sku下标签集合
  querySkuTags = <K extends T['ApiQuerySkuTags']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQuerySkuTags', data)
  // 查询sku列表
  querySkuPageList = <K extends T['ApiQuerySkuPageList']>(data: K['req']): Promise<K['res']> => this.post2('v2/ApiQuerySkuPageList', data)

  // 查询商品列表-不要待生效数据
  queryCommodityPageList = <K extends T['ApiQueryCommodityPageList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiQueryCommodityPageList', data)
  /**
   * 功能： 商品选择器
   * /api/commodity/sku/v1/selectElasticsearchCommoditySku
   */
  selectElasticsearchCommoditySku = <K extends T['ApiSelectElasticsearchCommoditySku']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectElasticsearchCommoditySku', data)

  /**
   * 功能：商品选择器 通过skuId查询提供sku详情
   * /api/commodity/sku/v1/findSkuSpuDetailList
   */
  findSkuSpuDetailList = <K extends T['ApiFindSkuSpuDetailList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiFindSkuSpuDetailList', data)

  /**
   * 功能：通过skuCodes查询提供sku详情
   * /api/commodity/sku/v1/batchFindSkuDetail
   */
  batchFindSkuDetail = <K extends T['ApiBatchFindSkuDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBatchFindSkuDetail', data)

  /**
   * 商品选择器-回显-通过skuCodes或skuIds查询sku
   * /api/commodity/sku/v1/selectSkuDetailByIdAndCode
   */
  selectSkuDetailByIdAndCode = <K extends T['ApiSelectSkuDetailByIdAndCode']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSelectSkuDetailByIdAndCode', data)
}
